var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDisk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "disk_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 3a1 1 0 0 1 .707.293l4 4A1 1 0 0 1 21 8v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM5 19h1.5v-5.25A1.75 1.75 0 0 1 8.25 12h7.5a1.75 1.75 0 0 1 1.75 1.75V19H19V8.414L15.586 5H5zm3.5 0h7v-5h-7zm5.75-12a1 1 0 1 1 0 2H9a1 1 0 0 1 0-2z"
})));
export default SvgDisk;